// tslint:disable
// cspell:disable
import * as React from 'react';

import { ChartData } from '../components/agent/agent-types';
import { ChartFeedPreview } from '../components/agent/chart-feed-preview';

// Test 1: Line Chart - Candidate Pipeline Over Time
const candidatePipelineLineChart: ChartData = {
    options: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        smooth: true,
        yAxisLabel: 'Count'
    },
    series: [
        { data: [45, 52, 48, 63, 71, 68], name: 'Sourced' },
        { data: [23, 28, 31, 35, 42, 39], name: 'In Progress' },
        { data: [12, 15, 18, 22, 28, 25], name: 'Client Interviews' },
        { data: [5, 7, 6, 9, 11, 10], name: 'Hired' }
    ],
    title: 'Candidate Pipeline Trends (Jan-Jun 2024)',
    type: 'line'
};

// Test 2: Horizontal Bar Chart - Candidates by Stage
const candidatesByStageBar: ChartData = {
    options: {
        categories: ['Sourced', 'Outreach Sent', 'Screening', 'Client Interview', 'Offer', 'Hired'],
        showDataLabels: true
    },
    series: [{ data: [45, 32, 28, 15, 8, 3], name: 'Candidates' }],
    title: 'Active Candidates by Recruitment Stage',
    type: 'horizontal-bar'
};

// Test 3: Pie Chart - Candidates by Experience Level
const experienceLevelPie: ChartData = {
    options: {
        categories: ['Senior (8+ years)', 'Mid-level (4-7 years)', 'Junior (1-3 years)', 'Entry-level (<1 year)']
    },
    series: [{ data: [45, 32, 18, 5], name: 'Distribution' }],
    title: 'Candidates by Experience Level',
    type: 'pie'
};

// Test 4: Donut Chart - Job Distribution by Client
const jobsByClientDonut: ChartData = {
    options: {
        categories: ['TechCorp', 'StartupXYZ', 'BigTech Solutions', 'FinanceApp Inc', 'HealthTech Co', 'Other']
    },
    series: [{ data: [12, 8, 15, 6, 4, 10], name: 'Jobs' }],
    title: 'Open Jobs by Client',
    type: 'donut'
};

// Test 5: Stacked Bar Chart - Monthly Activity by Type
const monthlyActivityStacked: ChartData = {
    options: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        stacked: true,
        yAxisLabel: 'Activities'
    },
    series: [
        { data: [120, 135, 142, 158, 165, 172], name: 'Sourcing' },
        { data: [45, 52, 48, 63, 71, 68], name: 'Screening' },
        { data: [23, 28, 31, 35, 42, 39], name: 'Interviews' },
        { data: [8, 12, 10, 15, 18, 16], name: 'Offers' }
    ],
    title: 'Monthly Recruiting Activity by Type',
    type: 'bar'
};

// Test 6: Area Chart - Cumulative Placements
const cumulativePlacementsArea: ChartData = {
    options: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        smooth: true
    },
    series: [{ data: [5, 12, 18, 27, 38, 48, 59, 70, 82, 93, 104, 115], name: 'Total Placements' }],
    title: 'Cumulative Placements 2024',
    type: 'area'
};

// Test 7: Multi-Series Line Chart - Team Performance
const teamPerformanceLine: ChartData = {
    options: {
        categories: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
        smooth: false,
        yAxisLabel: 'Candidates Placed'
    },
    series: [
        { data: [3, 5, 4, 6], name: 'Alice (Team Lead)' },
        { data: [2, 3, 5, 4], name: 'Bob (Senior)' },
        { data: [1, 2, 2, 3], name: 'Charlie (Junior)' }
    ],
    title: 'Weekly Team Performance - November',
    type: 'line'
};

// Test 8: Simple Vertical Bar Chart - Time to Fill by Job Type
const timeToFillBar: ChartData = {
    options: {
        categories: ['Engineering', 'Product', 'Design', 'Sales', 'Marketing'],
        showDataLabels: true,
        yAxisLabel: 'Days'
    },
    series: [{ data: [42, 35, 28, 31, 25], name: 'Average Time to Fill' }],
    title: 'Average Time to Fill by Department',
    type: 'bar'
};

// Test 9: Pie Chart - Candidate Source Distribution
const candidateSourcePie: ChartData = {
    options: {
        categories: ['LinkedIn', 'Referrals', 'Job Boards', 'Direct Outreach', 'Company Website']
    },
    series: [{ data: [42, 28, 15, 10, 5], name: 'Percentage' }],
    title: 'Candidate Source Distribution',
    type: 'pie'
};

// Test 10: Large Dataset Line Chart
const largeDatasetLine: ChartData = {
    options: {
        categories: Array.from({ length: 12 }, (_, i) => `Month ${i + 1}`),
        smooth: true
    },
    series: [
        {
            data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 50) + 20),
            name: 'Applications Received'
        },
        {
            data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 30) + 10),
            name: 'Interviews Conducted'
        },
        {
            data: Array.from({ length: 12 }, () => Math.floor(Math.random() * 15) + 5),
            name: 'Offers Made'
        }
    ],
    title: 'Annual Recruiting Metrics - Full Year View',
    type: 'line'
};

// Test 11: Horizontal Bar - Top Clients by Active Jobs
const topClientsBar: ChartData = {
    options: {
        categories: [
            'TechCorp Inc',
            'BigTech Solutions',
            'StartupXYZ',
            'FinanceApp Inc',
            'HealthTech Co',
            'DataCorp',
            'CloudServices LLC',
            'AI Innovations'
        ],
        showDataLabels: true
    },
    series: [{ data: [15, 12, 10, 8, 6, 5, 4, 3], name: 'Active Jobs' }],
    title: 'Top 8 Clients by Number of Active Jobs',
    type: 'horizontal-bar'
};

// Test 12: Stacked Area Chart - Candidate Status Over Time
const candidateStatusArea: ChartData = {
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
        smooth: true,
        stacked: true
    },
    series: [
        { data: [120, 145, 160, 180], name: 'Active' },
        { data: [45, 52, 58, 65], name: 'Placed' },
        { data: [15, 18, 22, 28], name: 'On Hold' }
    ],
    title: 'Candidate Status Distribution by Quarter',
    type: 'area'
};

// Test 13: Conversion Funnel - Vertical Grouped Bar (tests long labels)
const conversionFunnelVertical: ChartData = {
    options: {
        categories: [
            'Outreach → Response',
            'Response → Being Scheduled',
            'Being Scheduled → Screen Scheduled',
            'Screen Scheduled → Complete',
            'Screen Complete → AM Approval',
            'AM Approval → Client Feedback',
            'Client Feedback → First Round'
        ],
        showDataLabels: true
    },
    series: [
        { data: [4.2, 34.3, 58.3, 85.7, 58.3, 71.4, 80], name: 'Gradient Labs - Founding AE' },
        { data: [4.2, 36, 77.8, 71.4, 0, 50, 66.7], name: 'Gradient Labs - Founding AE (TM)' }
    ],
    title: 'Conversion Rate by Stage - Vertical Grouped Bars',
    type: 'bar'
};

// Test 14: Conversion Funnel - Horizontal Grouped Bar (tests dynamic margin calculation)
const conversionFunnelHorizontal: ChartData = {
    options: {
        categories: [
            'Outreach → Response',
            'Response → Being Scheduled',
            'Being Scheduled → Screen Scheduled',
            'Screen Scheduled → Screen Complete',
            'Screen Complete → Client Feedback',
            'Client Feedback → Client First Round'
        ],
        showDataLabels: true
    },
    series: [
        { data: [4.2, 34.3, 58.3, 85.7, 41.67, 60], name: 'Gradient Labs - Founding AE' },
        { data: [4.23, 36, 77.78, 71.43, 60, 83.67], name: 'Contentsquare - Founding AE (TM)' }
    ],
    title: 'Conversion Rate by Stage - Horizontal Grouped Bars (Long Labels)',
    type: 'horizontal-bar'
};

// CUSTOMIZATION TEST 1: Thick Lines with Large Points
const customLineThick: ChartData = {
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
        lineWidth: 6,
        pointSize: 12,
        smooth: true,
        yAxisLabel: 'Count'
    },
    series: [
        { data: [30, 45, 52, 48], name: 'Thick Line' },
        { data: [15, 25, 30, 35], name: 'Another Thick Line' }
    ],
    title: 'CUSTOMIZATION: Thick Lines (lineWidth: 6, pointSize: 12)',
    type: 'line'
};

// CUSTOMIZATION TEST 2: Thin Lines with No Points
const customLineThin: ChartData = {
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
        lineWidth: 1,
        showPoints: false,
        curve: 'natural'
    },
    series: [
        { data: [30, 45, 52, 48], name: 'Thin Line' },
        { data: [15, 25, 30, 35], name: 'Another Thin Line' }
    ],
    title: 'CUSTOMIZATION: Thin Lines No Points (lineWidth: 1, showPoints: false)',
    type: 'line'
};

// CUSTOMIZATION TEST 3: Wide Bars
const customBarWide: ChartData = {
    options: {
        barPadding: 0.1,
        borderRadius: 8,
        categories: ['Engineering', 'Product', 'Design', 'Sales'],
        showDataLabels: true
    },
    series: [{ data: [42, 35, 28, 31], name: 'Wide Bars' }],
    title: 'CUSTOMIZATION: Wide Rounded Bars (barPadding: 0.1, borderRadius: 8)',
    type: 'bar'
};

// CUSTOMIZATION TEST 4: Narrow Bars
const customBarNarrow: ChartData = {
    options: {
        barPadding: 0.4,
        borderRadius: 0,
        categories: ['Engineering', 'Product', 'Design', 'Sales'],
        showDataLabels: true
    },
    series: [{ data: [42, 35, 28, 31], name: 'Narrow Bars' }],
    title: 'CUSTOMIZATION: Narrow Square Bars (barPadding: 0.4, borderRadius: 0)',
    type: 'bar'
};

// CUSTOMIZATION TEST 5: Large Donut Hole
const customDonutLarge: ChartData = {
    options: {
        categories: ['Category A', 'Category B', 'Category C', 'Category D'],
        donutHoleSize: 0.7,
        slicePadding: 2
    },
    series: [{ data: [30, 25, 25, 20], name: 'Large Hole' }],
    title: 'CUSTOMIZATION: Large Donut Hole (donutHoleSize: 0.7, slicePadding: 2)',
    type: 'donut'
};

// CUSTOMIZATION TEST 6: Pie Chart (donutHoleSize: 0)
const customPieFromDonut: ChartData = {
    options: {
        categories: ['Category A', 'Category B', 'Category C', 'Category D'],
        donutHoleSize: 0,
        slicePadding: 0
    },
    series: [{ data: [30, 25, 25, 20], name: 'Pie (No Hole)' }],
    title: 'CUSTOMIZATION: Pie Chart via donutHoleSize (donutHoleSize: 0)',
    type: 'donut'
};

// CUSTOMIZATION TEST 7: Area Chart with Custom Opacity
const customAreaOpacity: ChartData = {
    options: {
        areaOpacity: 0.5,
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        lineWidth: 2,
        smooth: true
    },
    series: [{ data: [100, 120, 135, 150, 165, 180], name: 'High Opacity Area' }],
    title: 'CUSTOMIZATION: Area with High Opacity (areaOpacity: 0.5)',
    type: 'area'
};

// CUSTOMIZATION TEST 8: Legend Positioning
const customLegendTop: ChartData = {
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'],
        legendPosition: 'top'
    },
    series: [
        { data: [30, 45, 52, 48], name: 'Series 1' },
        { data: [15, 25, 30, 35], name: 'Series 2' },
        { data: [10, 20, 25, 30], name: 'Series 3' }
    ],
    title: 'CUSTOMIZATION: Legend at Top (legendPosition: "top")',
    type: 'line'
};

// ERROR TEST 1: Chart with malformed series (null data)
const errorTest1MalformedSeries: ChartData = {
    title: 'ERROR TEST: Malformed Series',
    type: 'line',
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4']
    },
    series: [
        { name: 'Valid Series', data: [10, 20, 30, 40] },
        null as any, // This will cause an error
        { name: 'Another Series', data: [5, 15, 25, 35] }
    ]
};

// ERROR TEST 2: Chart with mismatched data length
const errorTest2MismatchedData: ChartData = {
    title: 'ERROR TEST: Mismatched Data Length',
    type: 'bar',
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4'] // 4 categories
    },
    series: [
        { name: 'Too Much Data', data: [10, 20, 30, 40, 50, 60] } // 6 data points
    ]
};

// ERROR TEST 3: Pie chart with negative values
const errorTest3NegativeValues: ChartData = {
    title: 'ERROR TEST: Negative Pie Chart Values',
    type: 'pie',
    options: {
        categories: ['Category A', 'Category B', 'Category C']
    },
    series: [
        { name: 'Distribution', data: [50, -20, 30] } // Negative value
    ]
};

// ERROR TEST 4: Chart with undefined series
const errorTest4UndefinedSeries: ChartData = {
    title: 'ERROR TEST: Undefined Series',
    type: 'line',
    options: {
        categories: ['Q1', 'Q2', 'Q3', 'Q4']
    },
    series: undefined as any // This will cause an error
};

export const AgentChartTestPage: React.FC = () => {
    return (
        <div style={{ padding: '40px', background: '#f4f6f8', height: '100vh', overflow: 'auto' }}>
            <h1 style={{ marginBottom: '40px', color: '#333' }}>Chart Feed Item Component Tests</h1>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 1: Line Chart - Multi-Series Trends</h2>
                <ChartFeedPreview chart={candidatePipelineLineChart} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 2: Horizontal Bar Chart - Category Comparison
                </h2>
                <ChartFeedPreview chart={candidatesByStageBar} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 3: Pie Chart - Distribution</h2>
                <ChartFeedPreview chart={experienceLevelPie} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 4: Donut Chart - Distribution with Hole</h2>
                <ChartFeedPreview chart={jobsByClientDonut} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 5: Stacked Bar Chart - Breakdown Over Time</h2>
                <ChartFeedPreview chart={monthlyActivityStacked} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 6: Area Chart - Cumulative Growth</h2>
                <ChartFeedPreview chart={cumulativePlacementsArea} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 7: Line Chart - Team Comparison (No Smoothing)
                </h2>
                <ChartFeedPreview chart={teamPerformanceLine} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 8: Vertical Bar Chart - Simple Comparison</h2>
                <ChartFeedPreview chart={timeToFillBar} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 9: Pie Chart - Source Distribution</h2>
                <ChartFeedPreview chart={candidateSourcePie} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 10: Line Chart - Large Dataset (12 Months)</h2>
                <ChartFeedPreview chart={largeDatasetLine} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 11: Horizontal Bar Chart - Many Categories</h2>
                <ChartFeedPreview chart={topClientsBar} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>Test 12: Stacked Area Chart - Status Over Time</h2>
                <ChartFeedPreview chart={candidateStatusArea} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 13: Conversion Funnel - Vertical Grouped Bars (Long Category Labels)
                </h2>
                <ChartFeedPreview chart={conversionFunnelVertical} />
            </div>

            <div style={{ marginBottom: '60px' }}>
                <h2 style={{ color: '#666', marginBottom: '20px' }}>
                    Test 14: Conversion Funnel - Horizontal Grouped Bars (Dynamic Margin Calculation)
                </h2>
                <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
                    This chart tests dynamic left margin calculation for long category labels like "Screen Scheduled →
                    Screen Complete"
                </p>
                <ChartFeedPreview chart={conversionFunnelHorizontal} />
            </div>

            <h1
                style={{
                    margin: '80px 0 40px 0',
                    color: '#1976d2',
                    borderTop: '3px solid #1976d2',
                    paddingTop: '40px'
                }}
            >
                Visual Customization Tests
            </h1>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>
                    ⚙️ CUSTOMIZATION 1: Thick Lines with Large Points
                </h2>
                <ChartFeedPreview chart={customLineThick} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>
                    ⚙️ CUSTOMIZATION 2: Thin Lines with No Points
                </h2>
                <ChartFeedPreview chart={customLineThin} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>⚙️ CUSTOMIZATION 3: Wide Rounded Bars</h2>
                <ChartFeedPreview chart={customBarWide} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>⚙️ CUSTOMIZATION 4: Narrow Square Bars</h2>
                <ChartFeedPreview chart={customBarNarrow} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>⚙️ CUSTOMIZATION 5: Large Donut Hole</h2>
                <ChartFeedPreview chart={customDonutLarge} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>
                    ⚙️ CUSTOMIZATION 6: Pie Chart via donutHoleSize
                </h2>
                <ChartFeedPreview chart={customPieFromDonut} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>⚙️ CUSTOMIZATION 7: Area with High Opacity</h2>
                <ChartFeedPreview chart={customAreaOpacity} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #1976d2', padding: '20px', background: '#e3f2fd' }}>
                <h2 style={{ color: '#0d47a1', marginBottom: '20px' }}>⚙️ CUSTOMIZATION 8: Legend at Top</h2>
                <ChartFeedPreview chart={customLegendTop} />
            </div>

            <h1
                style={{
                    margin: '80px 0 40px 0',
                    color: '#d32f2f',
                    borderTop: '3px solid #ff5722',
                    paddingTop: '40px'
                }}
            >
                Error Boundary Tests
            </h1>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 1: Malformed Series (should trigger error boundary)
                </h2>
                <ChartFeedPreview chart={errorTest1MalformedSeries} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 2: Mismatched Data Length (should trigger error boundary)
                </h2>
                <ChartFeedPreview chart={errorTest2MismatchedData} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 3: Negative Pie Chart Values (should trigger error boundary)
                </h2>
                <ChartFeedPreview chart={errorTest3NegativeValues} />
            </div>

            <div style={{ marginBottom: '60px', border: '2px solid #ff5722', padding: '20px', background: '#fff3e0' }}>
                <h2 style={{ color: '#d32f2f', marginBottom: '20px' }}>
                    🔥 ERROR TEST 4: Undefined Series (should trigger error boundary)
                </h2>
                <ChartFeedPreview chart={errorTest4UndefinedSeries} />
            </div>
        </div>
    );
};
